module.exports = __webpack_public_path__ + "img/download.8413ccb6.png";